"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CardPersonalData", {
  enumerable: true,
  get: function get() {
    return _CardPersonalData.default;
  }
});
Object.defineProperty(exports, "CardValidaDocuments", {
  enumerable: true,
  get: function get() {
    return _CardValidaDocuments.default;
  }
});
Object.defineProperty(exports, "CardValidaFace", {
  enumerable: true,
  get: function get() {
    return _CardValidaFace.default;
  }
});
var _CardPersonalData = _interopRequireDefault(require("./CardPersonalData"));
var _CardValidaFace = _interopRequireDefault(require("./CardValidaFace"));
var _CardValidaDocuments = _interopRequireDefault(require("./CardValidaDocuments"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }